export enum VehicleUserStatus {
    Unknown,
    STANDARDUSER,
    PENDINGLIABLEUSER,
    LIABLEUSER,
    SPONSORUSER
}
